/**
 * defa.routers.LegacyRouter
 * The router for legacy functionality in Simplify.
 * @version 1.2.0
 */

const LegacyRouter = Mn.AppRouter.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	appRoutes: {
		'legacy/migrate(/)'    : 'showMigrate',
		'legacy/migrate/:id(/)': 'showMigrate',
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default LegacyRouter;